import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import DataField from "../../utils/DataField"
import AnalysisStatus from "../AnalysisStatusBox/AnalysisStatus/AnalysisStatus"
import FinancialResponsibleDialog from "./FinancialResponsibleDialog"
import { extractRentalAgreementParties, titleCase } from "../../utils/utils"
import { partyFraudStatus } from "../PartyDetails/partyStatus"

function FinancialResponsibleCard(props) {
    const { t } = useTranslation()
    const [dialogOpen, setDialogOpen] = useState(false)

    const { financialResponsible } = extractRentalAgreementParties(props.rental_agreement)

    return (
        <div className="analysisCard">
            <div className={["blueText", "subtitleSize"].join(" ")}>
                {t("financial_responsible")}
            </div>
            {financialResponsible == null ?
                <div
                    className={["labelText", "normalMediumSize"].join(" ")}
                    style={{ margin: "10px 0px" }}
                >
                    {t("no_financial_responsible")}
                </div>
                :
                <div className="labelSpace">
                    <DataField
                        title={t("name")}
                        label={titleCase(financialResponsible.name, "-")}
                        size={"normalMediumSize"}
                        titleNoWrap={true}
                        margin="10px"
                    />
                    <AnalysisStatus
                        name={t("analysis_status")}
                        status={partyFraudStatus(financialResponsible)}
                    />
                    <div
                        onClick={() => setDialogOpen(true)}
                        className={["blueText", "normalSmallSize", "link"].join(" ")}
                        style={{ margin: "10px 0px" }}
                    >
                        {t("details")}
                    </div>
                    <FinancialResponsibleDialog
                        open={dialogOpen}
                        onClose={() => setDialogOpen(false)}
                        party={financialResponsible}
                    />
                </div>
            }
        </div>
    )
}

export default FinancialResponsibleCard
